// extracted by mini-css-extract-plugin
module.exports = {"StandardTileBody":"Tile_StandardTileBody__35w_w","StandardTileTitle":"Tile_StandardTileTitle__r2ybM"};